import React from 'react';
import { Button, Label, Input } from 'reactstrap';
import GlobalModal from '../common-fun/GlobalModal';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onAccept: () => void;
  accepted: boolean;
  setAccepted: (val: boolean) => void;
  showCancel: boolean;
}

const TermsModal: React.FC<Props> = ({ isOpen, toggle, onAccept, accepted, setAccepted, showCancel = true }) => {
  const body = (
    <div className="terms-container ">
      <h2 className="mb-3 main-title d-flex justify-content-center">
        <img className="home-logo" src="content/images/header-logo.svg" style={{ maxWidth: '37px' }}></img> Terms & Conditions
      </h2>

      <div className="terms-content scrollable-content">
        <div className="term-section">
          <h6>1. Acceptance and Eligibility</h6>
          <ul>
            <li>
              <strong>Binding Agreement:</strong> By using 5plus.us, you agree to these Terms and Privacy Policy.
            </li>
            <li>
              <strong>Age Requirement:</strong> You must be 18 years or older.
            </li>
            <li>
              <strong>Changes:</strong> The Company can update these terms at any time; continued use constitutes acceptance of changes.
            </li>
          </ul>
        </div>

        <div className="term-section">
          <h6>2. Access and Account Security</h6>
          <ul>
            <li>
              <strong>Availability:</strong> The Company may withdraw or restrict the Website without notice.
            </li>
            <li>
              <strong>Accuracy:</strong> All registration info must be correct.
            </li>
            <li>
              <strong>Security:</strong> You are responsible for keeping your password confidential. Accounts are personal and
              non-transferable.
            </li>
            <li>
              <strong>Termination:</strong>The Company can disable any account at its discretion for violations.
            </li>
          </ul>
        </div>

        <div className="term-section">
          <h6>3. Intellectual Property</h6>
          <ul>
            <li>
              <strong>Ownership:</strong> All content (text, code, images) is owned by the Company or its licensors.
            </li>
            <li>
              <strong>Limited License:</strong> You may use the site for personal, non-commercial use only.
            </li>
            <li>
              <strong>Restrictions:</strong> You cannot modify, redistribute, or use site graphics without accompanying text. Commercial use
              is strictly prohibited.
            </li>
          </ul>
        </div>

        <div className="term-section">
          <h6>4. User Contributions & Conduct</h6>
          <ul>
            <li>
              <strong>License to Company:</strong> Any content you post is non-confidential. You grant the Company a perpetual right to use,
              modify, and distribute it.
            </li>
            <li>
              <strong>Content Standards:</strong> Contributions must not be illegal, defamatory, obscene, violent, or discriminatory.
            </li>
            <li>
              <strong>Prohibited Uses:</strong> No "spamming," impersonation, introducing viruses, or using "bots/spiders" to scrape data.
            </li>
            <li>
              <strong>Monitoring:</strong> The Company has the right to remove content or disclose user identity to law enforcement or
              third-party claimants.
            </li>
          </ul>
        </div>

        <div className="term-section">
          <h6>5. Disclaimers and Liability</h6>
          <ul>
            <li>
              <strong>"As Is" Basis: </strong> The Website is provided without warranties of any kind regarding accuracy or reliability.
            </li>
            <li>
              <strong>No Guarantee:</strong>The Company does not guarantee the site is free of viruses.
            </li>
            <li>
              <strong>Limitation of Liability:</strong> To the fullest extent of the law, the Company is not liable for damages (including
              loss of profits or data) arising from your use of the site.
            </li>
            <li>
              <strong>Indemnification:</strong> You agree to defend and pay for legal claims against the Company resulting from your
              violation of these terms.
            </li>
          </ul>
        </div>

        <div className="term-section">
          <h6>6. Legal Disputes</h6>
          <ul>
            <li>
              <strong>Governing Law: </strong> California law applies.
            </li>
            <li>
              <strong>Jurisdiction:</strong> Disputes are handled in Berkeley/Alameda County, CA.
            </li>
            <li>
              <strong>Arbitration:</strong> The Company may force disputes into binding arbitration via the American Arbitration
              Association.
            </li>
            <li>
              <strong>Claim Window:</strong> You must file any legal claim within <strong> one (1) year</strong> or it is permanently
              barred.
            </li>
          </ul>
        </div>
      </div>

      <div className="term-section contact-section">
        <h6>Contact</h6>
        <ul>
          <li>
            <strong>Copyright Issues:</strong> Please refer to our Copyright Policy.
          </li>
          <li>
            <strong>General Feedback:</strong> <a href="mailto:info@5plus.us">info@5plus.us</a>
          </li>
        </ul>
      </div>

      <div className="mt-3 d-flex align-items-center">
        <Input type="checkbox" checked={accepted} onChange={e => setAccepted(e.target.checked)} />
        <Label for="acceptTerms" className="ms-2 mb-0">
          I accept the Terms & Conditions
        </Label>
      </div>
    </div>
  );

  const footer = (
    <>
      {showCancel && (
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      )}
      <Button color="primary" disabled={!accepted} onClick={onAccept}>
        Accept
      </Button>
    </>
  );

  return <GlobalModal isOpen={isOpen} toggle={toggle} body={body} footer={footer} className="terms-modal" />;
};

export default TermsModal;
